import { render, staticRenderFns } from "./BadgeListCategory.vue?vue&type=template&id=f58ab020&"
import script from "./BadgeListCategory.vue?vue&type=script&lang=js&"
export * from "./BadgeListCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58ab020')) {
      api.createRecord('f58ab020', component.options)
    } else {
      api.reload('f58ab020', component.options)
    }
    module.hot.accept("./BadgeListCategory.vue?vue&type=template&id=f58ab020&", function () {
      api.rerender('f58ab020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badges/BadgeListCategory.vue"
export default component.exports